	
'use strict';

var model;

class Model {
	constructor() {
		this.name = 'mydashboard-model';
		
		this.global = null; // put by global on registration
		this.isready = false;
		this.isloading = false;

		model = this; // register

		this.mvcmydashboard = null;
	}

	init() {
		console.log('module init called for ' + this.name);
		

		var global = this.global;
		
		this.isready = true;
	
	}

	async initAsync() {
		console.log('module initAsync called for ' + this.name);
		
		try {
			const Client_Wallet = require('@primusmoney/client_wallet');
			const client_wallet = Client_Wallet.getObject();
			let clientglobal = client_wallet.getGlobalObject();
	
			await client_wallet.init();
	
			require('./mydashboard/module-load.js');
			this.mvcmydashboard = clientglobal.getModuleObject('mvc-mydashboard');
		}
		catch(e) {
			console.log('exception in Model.initAsync: ' + e);
		}	
	}



	// compulsory  module functions
	loadModule(parentscriptloader, callback) {
		console.log('loadModule called for module ' + this.name);
		
		if (this.isloading)
			return;
			
		this.isloading = true;

		var self = this;

		var modulescriptloader = parentscriptloader.getChildLoader('webclientmoduleloader');

		modulescriptloader.load_scripts(function() { 
			//self.init(); // init is called by index.js
			if (callback) callback(null, self); 
		});

		return modulescriptloader;	
	}
	
	isReady() {
		return this.isready;
	}

	hasLoadStarted() {
		return this.isloading;
	}

	// optional  module functions
	registerHooks() {
		console.log('module registerHooks called for ' + this.name);
		
		var global = this.global;
		
		global.registerHook('cleanSessionContext_hook', this.name, this.cleanSessionContext_hook);
		
		global.registerHook('getDefaultSchemeConfig_hook', this.name, this.getDefaultSchemeConfig_hook);
	}
	
	postRegisterModule() {
		console.log('postRegisterModule called for ' + this.name);
		if (!this.isloading) {
			var global = this.global;
			var self = this;
			var rootscriptloader = global.getRootScriptLoader();
			
			this.loadModule(rootscriptloader, () => {
				if (this.registerHooks)
				this.registerHooks();
			});
		}
	}

	//
	//
	//
	async getMvcMyDashboard() {
		if (this.mvcmydashboard)
			return this.mvcmydashboard;

		const Client_Wallet = require('@primusmoney/client_wallet');
		const client_vallet = Client_Wallet.getObject();
		let clientglobal = client_vallet.getGlobalObject();

		await client_vallet.init();

		this.mvcmydashboard = clientglobal.getModuleObject('mvc-mydashboard');

		return this.mvcmydashboard;
	}

	_getJQueryClass() {
		if (typeof window !== 'undefined' && window && (typeof window.simplestore !== 'undefined'))
		  return window.simplestore.jQuery;
		else if ((typeof global !== 'undefined') && (typeof global.simplestore !== 'undefined'))
			return global.simplestore.jQuery;
		else
		throw 'can not find JQuery class!!!';
	}

	async _loadExternalJSON(jsonfile) {
		// note: works only for properly formed json files content
		var _$ = this._getJQueryClass();

		var data = await new Promise((resolve, reject) => { 
			_$.getJSON(jsonfile, function(res) {
				if (res) resolve(res); else reject('no data');
			})
			.catch(err => {
				console.log('exception in _loadExternal: ' + err);
				reject('no data');
			});
		})
		.catch(err => {
			console.log('exception in _loadExternal: ' + err);
		});

		return data;
	}

	async setNameSpace(namespace) {
		this.namespace = namespace;
	}

	async loadConfig(configname) {
		var jsonfile = './config/' + (this.namespace ? this.namespace + '/'  : '') + configname + '.json';

		var config_json = await this._loadExternalJSON(jsonfile).catch(err => {});

		return config_json;
	}

	async getSchemeConfigFromName(schemename) {
		var scheme_config;

		var webapp_schemes = await this.loadConfig('schemes-webapp')
		.catch(err => {
			console.log('WebClient.initprod error loading webapp schemes: ' + err);
		});

		if (webapp_schemes) {
			scheme_config = webapp_schemes[schemename];
		}

		return scheme_config;
	}
	
	async getSchemeConfigFromUUID(schemeuuid) {
		var scheme_config;

		var webapp_schemes = await this.loadConfig('schemes-webapp')
		.catch(err => {
			console.log('WebClient.initprod error loading webapp schemes: ' + err);
		});

		for (var i = 0; i < (webapp_schemes ? webapp_schemes.length : 0); i++) {
			if (webapp_schemes[i].uuid === schemeuuid)
				return webapp_schemes[i];
		}
	}
	


	// static methods
	static getObject() {
		if (model)
			return model;
		
		model = new Model();
		
		return model;
	}
}

if ( typeof window !== 'undefined' && typeof window.GlobalClass !== 'undefined' && window.GlobalClass ) {
	var _GlobalClass = window.GlobalClass;
}
else if (typeof window !== 'undefined') {
	var _GlobalClass = ( window && window.simplestore && window.simplestore.Global ? window.simplestore.Global : null);
}
else if (typeof global !== 'undefined') {
	// we are in node js
	var _GlobalClass = ( global && global.simplestore && global.simplestore.Global ? global.simplestore.Global : null);
}

_GlobalClass.getGlobalObject().registerModuleObject(new Model());

//dependencies
_GlobalClass.getGlobalObject().registerModuleDepency('mydashboard-model', 'common');    

//module.exports = Model;
// does not work in webpack (TypeError: "exports" is read-only)